<template>
  <div>
    <SjLinkMenu title="162168.SH   19城建01" style="height: 800px;">
      <sj-button slot="options">切换</sj-button>
      <SjLinkMenuItem
        label="123"
        :labelRenderer="renderer"
        style="height: 500px;"
        >111</SjLinkMenuItem
      >
      <SjLinkMenuItem label="234" style="height: 500px;">222</SjLinkMenuItem>
      <SjLinkMenuItem label="456" style="height: 500px;">444</SjLinkMenuItem>
    </SjLinkMenu>
    <SjLinkMenu style="height: 600px;margin-top: 10px;" mode="vertical">
      <sj-button slot="menuOptions">切换</sj-button>
      <SjLinkMenuItem label="234" style="height: 500px;">222</SjLinkMenuItem>
      <SjLinkMenuItem label="456" style="height: 500px;">444</SjLinkMenuItem>
    </SjLinkMenu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      renderer: () => {
        return <div>yesyesyes</div>;
      }
    };
  }
};
</script>

<style scoped lang="less"></style>
